import { Image, ImageProps } from '@mantine/core';
import logo from '../../assets/logo.svg';

interface LogoProps extends Omit<ImageProps, 'src' | 'alt'> {
	height?: number;
	onClick?: () => void;
}

export function Logo({ height = 32, onClick, ...props }: LogoProps) {
	// const isDark = useIsDarkMode();
	// const logo = isDark ? logoSrc : logoSrc;

	return (
		<Image
			onClick={onClick}
			src={logo}
			alt="Codezo"
			fit="contain"
			style={{
				height: `${height}px`,
				maxHeight: `${height}px`,
				width: 'auto',
				maxWidth: '100%',
				cursor: onClick ? 'pointer' : 'default',
			}}
			{...props}
		/>
	);
}
